/**
 * Maps a 0-23 hour to the banner greeting's i18n KEY (in `my-space:dashboard`).
 * Returns a key rather than text so this stays a pure, testable function while
 * the greeting still follows the active language.
 */
export function greetingForHour(hour: number): string {
  if (hour < 5) return "dashboard.good_evening";
  if (hour < 12) return "dashboard.good_morning";
  if (hour < 17) return "dashboard.good_afternoon";
  return "dashboard.good_evening";
}
